import * as types from '../mutation-types'
import api from '@/api/news'

// initial state
const state = {
    news: {},
    loaded: false,
}

const getters = {
    newsSingle: state => state.news,
    newsSingleLoaded: state => state.loaded,
}

const actions = {
    getSingleNews({ commit }, id) {
        commit(types.SET_SINGLE_NEWS_LOADED, false );
        api.getNewsSingle(id, (response) => {
            commit(types.SET_SINGLE_NEWS, response );
            commit(types.SET_SINGLE_NEWS_LOADED, true );
        })
    },
}

const mutations = {
    [types.SET_SINGLE_NEWS] (state, news ) {
        state.news = news
    },
    [types.SET_SINGLE_NEWS_LOADED] (state, status ) {
        state.loaded = status
    },
}


export default {
    state,
    getters,
    actions,
    mutations
}


